export const ROUTES = {
  home: '/',
  products: '/products',
  tabletApp: '/tablet-app',
  download: '/download',
  partners: '/partners',
  buy: '/buy',
  contact: '/contact',
  news: '/news',
  warranty: '/extended-warranty',
  login: '/login',
  dashboard: '/dashboard',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

export interface NavLink {
  label: string;
  to: RoutePath;
}

/** Marketing destinations hidden once an operator is signed in (they live in the portal instead). */
export const SIGNED_IN_HIDDEN_ROUTES: readonly RoutePath[] = [ROUTES.tabletApp, ROUTES.partners];

/** Primary navigation, shared by the desktop header and the mobile drawer. */
export const PRIMARY_NAV: NavLink[] = [
  { label: 'Products', to: ROUTES.products },
  { label: 'Tablet App', to: ROUTES.tabletApp },
  { label: 'Download', to: ROUTES.download },
  { label: 'Partners', to: ROUTES.partners },
  { label: 'News', to: ROUTES.news },
  { label: 'Buy', to: ROUTES.buy },
];

export const FOOTER_NAV: { title: string; links: NavLink[] }[] = [
  {
    title: 'Products',
    links: [
      { label: 'All products & pricing', to: ROUTES.products },
      { label: 'Tablet LaunchPads', to: ROUTES.tabletApp },
      { label: 'Order a LaunchPad', to: ROUTES.buy },
      { label: 'Extended warranty', to: ROUTES.warranty },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'List your platform', to: ROUTES.partners },
      { label: 'News', to: ROUTES.news },
      { label: 'Contact us', to: ROUTES.contact },
    ],
  },
  {
    title: 'Operators',
    links: [
      { label: 'Operator login', to: ROUTES.login },
      { label: 'Dashboard', to: ROUTES.dashboard },
      { label: 'Download LaunchPad', to: ROUTES.download },
      { label: 'How it works', to: ROUTES.home },
    ],
  },
];

/** Header nav for the current auth state — signed-in operators skip Tablet App and Partners. */
export function getPrimaryNav(isAuthenticated: boolean): NavLink[] {
  if (!isAuthenticated) return PRIMARY_NAV;
  return PRIMARY_NAV.filter((link) => !SIGNED_IN_HIDDEN_ROUTES.includes(link.to));
}
